import React, { useState } from "react"
import PropTypes from "prop-types"
import DataTableItem from "./DataTableItem"
import CustomDrawer from "ui/Drawer";
import { Button } from "antd";

const DataTableResponsive = ({ data, onItemClick, extraRows, extraRowsResolver, actionIcon, actionIconResolver, onActionIconClick, getTableActions, labelMap, fieldOrder, fullsizeColumnOnMobile }) => {
  const [openActionDrawer, setOpenActionDrawer] = useState(false)
  const [currentRow, setCurrentRow] = useState(null);
  return (
    <>
      {data.map((listData) => {
        const resolvedActionIcon = actionIconResolver ? actionIconResolver(listData) : actionIcon;
        const resolvedExtraRows = extraRowsResolver ? extraRowsResolver(listData) : extraRows;
        return (
          <DataTableItem
            key={listData?.id || listData?.key}
            data={listData}
            extraRows={resolvedExtraRows}
            actionIcon={resolvedActionIcon}
            setOpenActionDrawer={getTableActions ? setOpenActionDrawer : undefined}
            onClick={() => onItemClick?.(listData)}
            onActionIconClick={() => {
              setCurrentRow(listData);
              if (onActionIconClick) onActionIconClick(listData);
              if (getTableActions) setOpenActionDrawer(true);
            }}
            labelMap={labelMap}
            fieldOrder={fieldOrder}
            fullsizeColumnOnMobile={fullsizeColumnOnMobile}
          />
        )
      })}

      <CustomDrawer open={openActionDrawer} setOpen={setOpenActionDrawer} title="More Actions"> {getTableActions?.(currentRow)?.map((action, idx) => (
        <Button
          key={action.label || idx}
          variant={action.variant || 'default'}
          color={action.color || 'default'}
          className="w-full mb-2"
          onClick={() => action.onClick(currentRow)}
        >
          {action.label}
        </Button>
      ))}</CustomDrawer>
    </>
  )
}

DataTableResponsive.propTypes = {
  data: PropTypes.array.isRequired,
  onItemClick: PropTypes.func,
  extraRows: PropTypes.node,
  extraRowsResolver: PropTypes.func,
  actionIcon: PropTypes.node,
  actionIconResolver: PropTypes.func,
  onActionIconClick: PropTypes.func,
  getTableActions: PropTypes.func,
  labelMap: PropTypes.object,
  fieldOrder: PropTypes.array,
  fullsizeColumnOnMobile: PropTypes.bool
}

export default DataTableResponsive

